import React, { useState, useEffect } from "react";
import StudentHeader from "../header";
import Footer from "../../footer";
import StudentSideBar from "../sidebar";
import { getIdData as getParameterName } from "../../../lib/parameters"
import {updateData ,addData ,getIdData} from "../../../lib/studentpersonalquestion"
import {useAuth} from "../../../usercontext";

import { useNavigate, useParams } from 'react-router-dom';

export default function StudentPersonalQuestionEdit() {

  const [answer, setAnswer] = useState();
  const [question, setQuestion] = useState();
  const [lessons, setLessons] = useState();
  const [grade, setGrade] = useState([]);
  const { profile } = useAuth();
  const navigate = useNavigate();
  let { slug ,Id} = useParams();

  const studentId = profile.id;
  console.log("slug",slug,Id);

  async function GetParameterData() {
    const qdata = await getParameterName(slug);
    console.log("qdata",qdata[0].pname);
    setQuestion(qdata[0].pname);
  }

  async function GetAnswer() {
    const answerdata = await getIdData(Id);
    console.log("answerdata",answerdata);
    if(answerdata.length > 0)
    setAnswer(answerdata[0].studentAnswer);
  }

function getGrade(les) {

  if (slug !== "Add")
    {
      const result = grade.filter(item => item.lesson === les )
      return result[0].grade;
    }
    else return 0;
}

function getRecordId(les) {

  if (slug !== "Add")
    {
      const result = grade.filter(item => item.lesson === les )
      return result[0].id;
    }
    else return 0;
}

  async function GetData(id) {
    //const lesson = await getDataForMonths(studentId,"month");
    //console.log("lesson",lesson);
    //setGrade(lesson);
    //const obj = JSON.parse(collage[0].rankvalue);
    //setCname(collage[0].collegename)
    //console.log("collage",collage , id);
    //setRanks(obj);

    GetParameterData();
  }

async function AddGradeData(lesson,grade) {
 /*
  await addData({
    studentId: studentId,
    month: month,
    lesson: lesson,
    grade:grade
  });*/
}


async function UpdateGradeData(lesson,grade) {
  await updateData({
    Id:slug,
    //studentId: studentId,
    //month: month,
    //lesson: lesson,
    grade:grade
  });
}
  const handleSubmit = async (e) => {
      e.preventDefault();
      console.log("Id", Id);
      if(Id == 0)
      {
        console.log("Yeni");

        await addData({
          studentId: studentId,
          questionId: slug,
          isAnswer: true,
          studentAnswer:answer
        });

      }
      else
      {
        console.log("Eski");

        await updateData({
          id:Id,
          studentAnswer:answer
        });
      }

      navigate("/student/student-personal-questions");
 
  };

  useEffect(() => {
    GetParameterData();
    
    if (Id !== 0) {
      GetAnswer();
    }
    
  }, [slug,profile])


  return (
            <div className="col-12">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Update Answer</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Question : {question}
                            </label>
                            
                          </div>
                        </div>
                        <form method="post"  onSubmit={handleSubmit}>
                        <div className="col-9">
                          <div className="form-group"></div>
                          </div>
                        <div className="col-9">
                          <div className="form-group">
                          <label className="form-control-label">
                              Answer 
                            </label>
                            <p>
                            <textarea className="form-control" value={answer}
                              onChange={(e) => setAnswer(e.target.value)}></textarea>
                            </p>
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            Update Answer
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                        </form>
                      </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
